export function StaticsFinal(target: any): void {
	Object.freeze(target);
}

@StaticsFinal
export class Constants {
    public static readonly CBMAbbreviation = 'CBM';
    public static readonly ClientAdministrator = "ClientAdministrator";
    public static readonly ClientUpsertError = 'An error occurred during client synchronization.';
    public static readonly CPIAbbreviation = 'CPI';
    public static readonly CoachImpersonate = "CoachImpersonate";
    public static readonly CorporationAdministrator = "CorporationAdministrator";
    public static readonly DMSAbbreviation = 'DMS';
    public static readonly EmailRegEx = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    public static readonly Failed = 'Failed';
    public static readonly FormNotUpdated = 'Please update at least one field.';
    public static readonly FromHuronAccelerators = "From: Huron Accelerators"
    public static readonly HDVAbbreviation = 'HDV';
    public static readonly HuronAcceleratorsAbbreviation = "HAP";
    public static readonly HuronAdministrator = "HuronAdministrator";
    public static readonly HuronSupport = "HuronSupport";
    public static readonly LeaderEvaluationManager = 'LEADER EVALUATION MANAGER';
    public static readonly LEMAbbreviation = 'LEM';
    public static readonly NotificationAllUser = "All Users";
    public static readonly NotificationClient = "Client";
    public static readonly NotificationContains = "contains";
    public static readonly NotificationCustomize = "Customize";
    public static readonly NotificationDateFormat = "EEE MM/dd";
    public static readonly NotificationDateTimeFormat = "EEE h a";
    public static readonly NotificationEmail = "email";
    public static readonly NotificationFontAcceptedValues = ['Arial', 'Courier New', 'Georgia', 'Impact', 'Lucida Console', 'Tahoma', 'Times New Roman', 'Verdana'];
    public static readonly NotificationHeaderAcceptedValues = ['false', '1', '2', '3', '4', '5'];
    public static readonly NotificationMessageHighPriority = "message.highPriority";
    public static readonly NotificationMessageMessagebox = "message.messageBox";
    public static readonly NotificationName = "name";
    public static readonly NotificationSizeAcceptedValues = ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'];
    public static readonly NotificationTitle = "title";
    public static readonly NotificationToEmailCheckBox = "to.emailCheckBox";
    public static readonly NotificationToReceiverClient = "to.receiverClient";
    public static readonly NotificationToReceiver = "to.receiver";
    public static readonly NotificationToReceiverEmail = "to.receiverEmail";
    public static readonly OrganizationSaveError = 'An error occurred during client/organization data synchronization.';
    public static readonly PatientCallManager = 'PATIENT CALL MANAGER';
    public static readonly PCMAbbreviation = 'PCM';
    public static readonly PhoneRegEx = new RegExp(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im);
    public static readonly SaveSuccess = 'Your changes were successfully saved';
    public static readonly SsoNameRegEx = new RegExp(/^[a-zA-Z0-9@_\-.()\\\/\*]*$/);
    public static readonly Synced = 'Synced';
    public static readonly TokenName = 'Token';
    public static readonly User = "User";
    public static readonly UserAdministrator = "UserAdministrator";
    public static readonly ValidationMatrix = 'VALIDATION MATRIX';
    public static readonly ValidationFailure = 'You must enter values for all required fields before saving.';
    public static readonly VMAbbreviation = 'VM';
    public static readonly NewClient = "New Client";
    public static readonly AdvancedFilters = "Advanced Filters";
    public static readonly HRIAbbreviation = 'HRI';
    public static readonly HURAbbreviation = 'HuR';
    public static readonly SaveSuccessNotification = 'Notification request has been successfully submitted. The intended recipients will receive email when the delivery process is complete.';
    public static readonly AutoCompleteSearchDefaultText = 'Please enter atleast 2 characters';
  	public static readonly NoDataText = 'No data to display';
  	public static readonly MinimunSearchLength = 2;
}

interface IUserRole {
	roleId: number;
	name: string;
}

export const UserRoles: Array<IUserRole> = Array(
	{ roleId: 1, name: Constants.HuronAdministrator },
	{ roleId: 2, name: Constants.CorporationAdministrator },
	{ roleId: 3, name: Constants.User },
	{ roleId: 4, name: Constants.HuronSupport },
	{ roleId: 5, name: Constants.CoachImpersonate },
	{ roleId: 6, name: Constants.UserAdministrator },
	{ roleId: 7, name: Constants.ClientAdministrator }
);

@StaticsFinal
export class LoginMethodSettingConstants {
	static readonly None = 'None';
	static readonly LDAP = 'LDAP';
	static readonly WSFed = 'WSFed';
	static readonly SAML2P = 'SAML2P';
}
